const { MinimogThemeStyles, MinimogThemeScripts } = window;
class QuickView {
  constructor() {
    this.modal = new MinimogTheme.Modal;
    this.isOpen = false;
    this.requestVersion = 0;
    this.pendingHandle = null;
    addEventDelegate({ selector: '.m-product-quickview-button', handler: (event, target) => {
      event.preventDefault();
      const handle = target.dataset.productHandle;
      if (handle) this.fetchHtml(handle, target);
    } });
    window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, () => {
      if (this.modal) MinimogTheme.ProductQuickView.close();
    });
  }
  fetchHtml(handle, target = this.target) {
    if (this.pendingHandle === handle) return this.pendingRequest;
    this.toggleLoading(this.target, false);
    this.target = target;
    this.toggleLoading(target, true);
    const version = ++this.requestVersion;
    this.pendingHandle = handle;
    const finish = () => {
      if (version !== this.requestVersion) return;
      this.toggleLoading(target, false);
      this.pendingHandle = null;
      this.pendingRequest = null;
    };
    this.pendingRequest = Promise.resolve().then(() => {
      loadAssetsNew([MinimogThemeStyles.product, MinimogThemeStyles.productInventory], 'quick-view-assets');
      return fetchSection('product-quickview', { url: `${window.MinimogSettings.base_url}products/${handle}` });
    }).then(section => {
      if (version !== this.requestVersion) return;
      const content = section.querySelector('.m-product-quickview');
      if (!content) throw new Error('Quick view content unavailable');
      if (section.querySelector('product-model')) {
        loadAssetsNew([MinimogThemeScripts.productModel, 'https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css'], 'product-model-assets');
      }
      loadAssetsNew([MinimogThemeScripts.productMedia, MinimogThemeScripts.variantsPicker, MinimogThemeScripts.productInventory], 'variants-picker', () => {
        if (version !== this.requestVersion) return;
        try {
          this.modalContent = content;
          this.mediaGallery = content.querySelector('media-gallery');
          this.modal.appendChild(content);
          this.modal.setWidth('960px');
          this.modal.open();
          this.modal.setSizes(`m-gradient ${content.dataset.colorScheme}`);
          this.isOpen = true;
        } finally { finish(); }
      });
    }).catch(error => {
      if (version !== this.requestVersion) return;
      finish();
      console.error(error);
    });
    return this.pendingRequest;
  }
  close(event) {
    ++this.requestVersion;
    this.toggleLoading(this.target, false);
    this.pendingHandle = null;
    this.pendingRequest = null;
    this.modal.close(event);
    this.isOpen = false;
  }
  toggleLoading(target, loading) {
    if (target) target.classList[loading ? 'add' : 'remove']('m-spinner-loading');
  }
}
MinimogTheme.ProductQuickView = new QuickView;
